/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { render } from 'react-dom';
import PortalIdParser from 'PortalIdParser'; //I18n Configuration

import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import registerAllData from 'I18n/init/register/lazy/registerAllData';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import 'I18n/init/data/allTimezones';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/currency';
import 'I18n/init/data/publicLocales'; // import { allSelectors } from 'DesignData/debugging/mess-with-selectors';
// import { attachStatHelpersToWindow } from 'DesignData/debugging/selector-stat-helpers';

import Raven from 'raven-js';
import { IDE } from 'DesignData/enums/AppContexts';
import auth from 'DesignData/lib/app/Auth';
import { RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import rhumbConfig from '../rhumb-config.yaml'; // Redux

import 'redux';
import { Provider } from 'react-redux';
import configureStore from 'DesignManagerIde/utils/redux/configureStore'; // Configure the router

import { createBrowserHistory } from 'history';
import { Router } from 'react-router-dom';
import Routes from 'DesignManagerIde/Routes';
import { fetch as fetchTabs } from 'DesignData/actions/Tabs'; // Onboarding

import UITour from 'ui-shepherd-react/tour/UITour';
import MultiTourHandlerSingleton from 'ui-shepherd-react/lib/MultiTourHandlerSingleton';
import { tours, toursArray, existingUserTour, newUserTour } from 'DesignData/constants/Onboarding';
import { LOCATION_CHANGE } from 'DesignData/reducers/Routing';
import AccessErrorPage from 'DesignComponents/pages/AccessErrorPage';
import ErrorBoundary from 'DesignComponents/errors/ErrorBoundary';

function makeTourHandler() {
  const tourHandler = MultiTourHandlerSingleton.getInstance();
  tourHandler.registerTour(tours.EXISTING_USER_IDE, existingUserTour);
  tourHandler.registerTour(tours.NEW_USER_IDE, newUserTour);
  return tourHandler;
}

const tourHandler = makeTourHandler();
export default class Application {
  start() {
    if (window.jasmine) return;
    window.AppInstance = this; // attachStatHelpersToWindow(allSelectors);

    this.init().then(() => {
      if (!auth.isAllowed()) {
        this.renderAccessErrorPage();
        return;
      }

      const {
        user
      } = auth.get();
      Raven.setUserContext({
        id: user.user_id,
        email: user.email,
        locale: user.locale
      });
      this.startRedux();
      this.startRouter();
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }

  init() {
    const authenticate = auth.init();
    const I18nProvider = createStandardI18nProvider();
    const langAvailable = Promise.all([I18nProvider.register(lang), registerAllData(I18nProvider)]);
    authenticate.then(({
      user,
      portal
    }) => {
      I18nProvider.setLocale({
        locale: user.locale,
        langEnabled: user.lang_enabled,
        timezone: portal.timezone
      });
    });
    PortalIdParser.get();
    return Promise.all([authenticate, langAvailable]);
  }

  createLocationChangedAction(store) {
    return location => {
      store.dispatch({
        type: LOCATION_CHANGE,
        payload: location
      });
    };
  }

  startRedux() {
    const history = createBrowserHistory({
      basename: `/design-manager/${PortalIdParser.get()}`
    });
    this.store = configureStore({
      auth: auth.get(),
      app: {
        context: IDE
      }
    }, history);
    this.history = history;
    const locationChangedListener = this.createLocationChangedAction(this.store);
    history.listen(locationChangedListener); // react-router-redux dispatches LOCATION_CHANGE on load which we've relied on
    // so we're doing the same here

    if (history.location) {
      locationChangedListener(history.location);
    }

    this.store.dispatch(fetchTabs());
  }

  startRouter() {
    this.render( /*#__PURE__*/_jsx(RhumbProvider, {
      config: rhumbConfig,
      history: historyAdapter(this.history),
      children: /*#__PURE__*/_jsx(ErrorBoundary, {
        boundaryName: "application",
        children: /*#__PURE__*/_jsx(UITour, {
          multiTourHandler: tourHandler,
          tours: toursArray,
          className: "tour-container",
          children: /*#__PURE__*/_jsx(Provider, {
            store: this.store,
            children: /*#__PURE__*/_jsx(Router, {
              history: this.history,
              children: /*#__PURE__*/_jsx(Routes, {})
            })
          })
        })
      })
    }));
  }

  renderAccessErrorPage() {
    this.render( /*#__PURE__*/_jsx(AccessErrorPage, {}));
  }

  render(renderedComponent) {
    render(renderedComponent, this.pageContainerEl, this.onRenderedOrUpdated.bind(this));
  }

  get pageContainerEl() {
    if (this.__pageContainerEl) return this.__pageContainerEl;
    this.__pageContainerEl = document.body.querySelector('.page');
    return this.__pageContainerEl;
  }

  onRenderedOrUpdated() {
    this.pageContainerEl.classList.toggle('un-rendered', false);
  }

}